module.exports = {"forma-equipos":"Form two teams","continuar":"Continue","azul":"Blue","naranja":"Orange"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/init/it.json
// module id = 180
// module chunks = 5